import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Landing from "../Landing/Landing";
import Home from "../Landing/Home";
import Dashboard from "../Landing/Dashboard";
import Dashboard2 from "../Landing/Dashboard2";
import Login from "../UserAuthentication/Login";
import Signup from "../UserAuthentication/SignUp";
import forgotpassword from "../UserAuthentication/Forgotpassword";
import Resetpassword from "../UserAuthentication/Resetpassword";
import UserProfile from "../UserAuthentication/UserProfile";
import ChangePassword from "../UserAuthentication/ChangePassword";
import LandingPage from "../Landing/LandingPage";
import Settings from "../Settings/Settings";
import NoPageFound from "../Landing/NoPageFound";

import Users_List from "../Users/Users_List";
import Users_Add from "../Users/Users_Add";
import Users_Edit from "../Users/Users_Edit";
import Users_Requests from "../Users/Users_Requests";
import Roles_List from "../Roles/Roles_List";
import Roles_Add from "../Roles/Roles_Add";
import District_List from "../District/District_List";
import District_Add from "../District/District_Add";
import HCF_List from "../HCF/HCF_List";
import HCF_Add from "../HCF/HCF_Add";
import XpertSite_List from "../XpertSites/XpertSite_List";
import XpertSite_Add from "../XpertSites/XpertSite_Add";
import PatientSample_List from "../PatientSamples/PatientSample_List";
import PatientSample_Add from "../PatientSamples/PatientSample_Add";
import PatientSamples_Dispatch from "../PatientSamples/PatientSamples_Dispatch";
import Patients_List from "../Patients/Patients_List";
import Patients_Add from "../Patients/Patients_Add";
import HCFCluster_List from "../HCFCluster/HCFCluster_List";
import HCFCluster_Add from "../HCFCluster/HCFCluster_Add";
import HCFCluster_Edit from "../HCFCluster/HCFCluster_Edit";
import QRCode_Printing from "../PatientSamples/QRCode_Printing";
import SamplesToReceive_List from "../SamplesToReceive/SamplesToReceive_List";
import Province_List from "../Province/Province_List";
import Province_Add from "../Province/Province_Add";
import Tehsil_List from "../Tehsil/Tehsil_List";
import Tehsil_Add from "../Tehsil/Tehsil_Add";
import Assignments_List from "../Assignments/Assignments_List";
import RiderIncentives from "../Finance/RiderIncentives";
import RiderPayments from "../Finance/RiderPayments";
import AddPatientFromUrl from "../SmsURLsComponent/AddPatientFromUrl";
import APKDownloadPage from "../Landing/APKDownloadPage";
//import APKUpdatePage from "../Landing/APKUpdatePage";
import NoVersionAPKDownloadPage from "../Landing/NoVersionAPKDownloadPage";
import RiderProfiles from "../Assignments/RiderProfiles";

import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import Administartor_Add from "../Administrator/Administartor_Add";
import Administrators_List from "../Administrator/Administrators_List";
import SubRecipient_List from "../SubRecipient/SubRecipient_List";
import SubRecipient_Add from "../SubRecipient/SubRecipient_Add";
import DistrictWiseTarget_List from "../DistrictWiseTargets/DistrictWiseTarget_List";
import ActivityLogs_List from "../Activity/ActivityLogs_List";
import DistrictWiseTarget_Add from "../DistrictWiseTargets/DistrictWiseTarget_Add";
import Dispute_Add from "../Dispute/Dispute_Add";
import Dispute_List from "../Dispute/Dispute_List";
import DistrictWiseTarget_Stats from "../DistrictWiseTargets/DistrictWiseTarget_Stats";
import XpertSiteProfiles from "../XpertSites/XpertSiteProfiles";
import HCF_Profile from "../HCF/HCF_Profile";
import AssignedDFS_Riders from "../Users/AssignedDFS_Riders";
import HeatMap_List from "../HeatMap/HeatMap_List";
import MapComponent from "../HeatMap/GoogleMap";
import ProvinceReport from "../Reports/Province/Province_List";
import DistrictReport from "../Reports/District/District_List";
import SrReport from "../Reports/SR/SR_List";
import HcfIncentives from "../Finance/HcfIncentives";
import HelpDesk_List from "../HelpDesk/Help_List";
import HelpDesk_Add from "../HelpDesk/Help_Add";
import Edit from "../HelpDesk/Edit"

class RouterComponent extends Component {
	render() {
		return (
			<div>
				<Router>
					<div>
						<Route path="/Receive_SMS" component={AddPatientFromUrl} />

						<Route path="/PrivacyPolicy" component={PrivacyPolicy} />
						<Route path="/TermsAndConditions" component={TermsAndConditions} />

						{/* <Route path="/Download_AndroidAPK" component={APKDownloadPage} />
						<Route path="/Update_AndroidAPK" component={APKUpdatePage} />
						<Route
							path="/Download_NoVersionAndroidAPK"
							component={NoVersionAPKDownloadPage}
						/> */}
						<Route path="/RiderProfiles" component={RiderProfiles} />

						<Route path="/NoPageFound" component={NoPageFound} />
						<Route exact path="/LandingLoader" component={Landing} />
						<Route exact path="/" component={LandingPage} />
						<Route path="/Home" component={Home} />
						<Route path="/Dashboard" component={Dashboard} />
						<Route path="/Dashboard2" component={Dashboard2} />
						<Route path="/Login" component={Login} />
						<Route path="/Register" component={Signup} />
						<Route path="/Reset_Password" component={Resetpassword} />
						<Route path="/Forgot_Password" component={forgotpassword} />
						<Route path="/User_Profile" component={UserProfile} />
						<Route path="/Change_Password" component={ChangePassword} />
						<Route path="/Settings" component={Settings} />

						<Route path="/Province_Report" component={ProvinceReport} />
						<Route path="/SR_Report" component={SrReport} />
						<Route path="/District_Report" component={DistrictReport} />

						<Route path="/Users" component={Users_List} />
						<Route path="/User_Add" component={Users_Add} />
						<Route path="/User_Edit/:Id" component={Users_Edit} />
						<Route path="/User_Requests" component={Users_Requests} />

						<Route path="/Roles" component={Roles_List} />
						<Route path="/Map" component={MapComponent} />
						<Route path="/Roles_Add" component={Roles_Add} />
						<Route path="/Roles_Edit/:Id" component={Roles_Add} />

						<Route path="/Administrators" component={Administrators_List} />
						<Route path="/Administartor_Add" component={Administartor_Add} />
						<Route
							path="/Administartor_Edit/:id"
							component={Administartor_Add}
						/>

						<Route path="/SubRecipient_List" component={SubRecipient_List} />
						<Route path="/SubRecipient_Add" component={SubRecipient_Add} />
						<Route path="/SubRecipient_Edit/:id" component={SubRecipient_Add} />

						<Route
							path="/DistrictWise_Target"
							component={DistrictWiseTarget_List}
						/>
						<Route
							path="/DistrictWiseTarget_Add"
							component={DistrictWiseTarget_Add}
						/>
						<Route
							path="/DistrictWiseTarget_Edit/:id"
							component={DistrictWiseTarget_Add}
						/>
						<Route
							path="/DistrictWiseTarget_Stats/:id"
							component={DistrictWiseTarget_Stats}
						/>

						<Route path="/Dispute_Add" component={Dispute_Add} />
						<Route path="/Dispute_List" component={Dispute_List} />
						<Route path="/Dispute_Edit/:id" component={Dispute_Add} />

						<Route path="/Province" component={Province_List} />
						<Route path="/Province_Add" component={Province_Add} />
						<Route path="/Province_Edit/:Id" component={Province_Add} />

						<Route path="/Districts" component={District_List} />
						<Route path="/District_Add" component={District_Add} />
						<Route path="/District_Edit/:Id" component={District_Add} />

						<Route path="/Tehsil" component={Tehsil_List} />
						<Route path="/Tehsil_Add" component={Tehsil_Add} />
						<Route path="/Tehsil_Edit/:Id" component={Tehsil_Add} />

						<Route path="/BHUAndRHC" component={HCF_List} />
						<Route path="/HCFProfiles" component={HCF_Profile} />
						<Route path="/BHUAndRHC_Add" component={HCF_Add} />
						<Route path="/BHUAndRHC_Edit/:Id" component={HCF_Add} />

						<Route path="/Heat_Map" component={HeatMap_List} />

						<Route path="/Xpert_Sites" component={XpertSite_List} />
						<Route path="/Xpert_SitesProfiles" component={XpertSiteProfiles} />
						<Route path="/XpertSite_Add" component={XpertSite_Add} />
						<Route path="/XpertSite_Edit/:Id" component={XpertSite_Add} />

						<Route path="/Patient_Samples" component={PatientSample_List} />
						<Route path="/PatientSample_Add" component={PatientSample_Add} />
						<Route
							path="/PatientSample_Edit/:Id"
							component={PatientSample_Add}
						/>
						<Route path="/Sample_QRCode_Printing" component={QRCode_Printing} />

						<Route path="/Patients" component={Patients_List} />
						<Route path="/Patients_Add" component={Patients_Add} />
						<Route path="/Patients_Edit/:Id" component={Patients_Add} />
						<Route
							path="/PatientSamples_Dispatch"
							component={PatientSamples_Dispatch}
						/>

						<Route path="/BHUAndRHCClusters" component={HCFCluster_List} />
						<Route path="/BHUAndRHCClusters_Add" component={HCFCluster_Add} />
						<Route path="/BHUAndRHCClusters_Edit/:Id" component={HCFCluster_Edit}
						/>

						<Route
							path="/Samples_To_Receive"
							component={SamplesToReceive_List}
						/>

						<Route path="/AssignedDFS_Riders" component={AssignedDFS_Riders} />

						<Route path="/Jobs" component={Assignments_List} />

						<Route path="/RiderIncentives" component={RiderIncentives} />
						<Route path="/RiderPayments" component={RiderPayments} />

						<Route path="/HcfIncentives" component={HcfIncentives} />

						<Route path="/Activity_List" component={ActivityLogs_List} />
						<Route path="/HelpDesk" component={HelpDesk_List} />
						<Route path="/HelpDesk_Add" component={HelpDesk_Add} />
						<Route path="/editpost" component={Edit} />
					</div>
				</Router>
			</div>
		);
	}
}
export { RouterComponent as default };
